import * as React from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import scopus from "../../../assets/img/scopus.png";
import thomson from "../../../assets/img/thomsonReuters.png";
import google from "../../../assets/img/googleScholar.png";
import sinta from "../../../assets/img/garuda.png";
import { startKeycloakLogin } from "../../../keycloak";
import bookmarkImage from "../../../assets/img/bookmark.png";
import unsamLogo from "../../../assets/img/unsam.png";

const icons = {
  chart: <path d="M4 19h16M7 16V9m5 7V5m5 11v-4" />,
  archive: <path d="M4 7h16M6 7v11h12V7M9 11h6M8 4h8l2 3H6l2-3Z" />,
  login: (
    <path d="M10 17l5-5-5-5M15 12H3m12-8h4a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-4" />
  ),
  menu: <path d="M4 7h16M4 12h16M4 17h16" />,
  close: <path d="M6 6l12 12M18 6 6 18" />,
  users: (
    <path d="M16 19a4 4 0 0 0-8 0M12 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm6 8a3 3 0 0 0-3-3M17 9a3 3 0 0 0 0-6" />
  ),
  calendar: (
    <path d="M7 3v3m10-3v3M4 9h16M6 5h12a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2Z" />
  ),
};

function Icon({ name, className = "h-4 w-4" }) {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      {icons[name]}
    </svg>
  );
}

function StatItem({ children }) {
  return (
    <span className="inline-flex shrink-0 items-center gap-2 rounded-full border border-slate-200 bg-white px-3 py-1.5 text-xs font-extrabold text-slate-700 shadow-sm sm:text-sm">
      {children}
    </span>
  );
}

function HeaderLogin({ data = {}, publikasi = [], grafik }) {
  const [open, setOpen] = React.useState(false);
  const [apiStats, setApiStats] = React.useState(null);

  React.useEffect(() => {
    axios.get('/header-stats-get')
      .then((res) => {
        if (res.data) setApiStats(res.data);
      })
      .catch((err) => console.error("Gagal memuat header stats:", err));
  }, []);

  const formattedDate = new Intl.DateTimeFormat("id-ID", {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
  }).format(new Date());

  const goToGrafik = () => {
    grafik?.();
    setOpen(false);
  };

  const login = () => {
    startKeycloakLogin();
    setOpen(false);
  };

  const getStats = () => {
    if (apiStats) return apiStats; // Gunakan API baru jika sudah di-load

    const pubs = Array.isArray(publikasi) && publikasi.length > 0 ? publikasi : (Array.isArray(data) ? data : data?.publikasi);

    if (pubs && Array.isArray(pubs)) {
      let scopus = 0, thomson = 0, google = 0, sinta = 0;
      const akunSet = new Set();

      pubs.forEach(item => {
        const asal = String(item?.asal_data || '').toUpperCase();
        if (asal === 'SINTA') sinta++;
        else if (asal === 'GOOGLE SCHOLAR') google++;
        else if (asal === 'WEB OF SCIENCE' || asal === 'THOMSON REUTERS') thomson++;
        else if (asal === 'SCOPUS') scopus++;

        if (Array.isArray(item?.penulis)) {
          item.penulis.forEach(p => {
            if (p?.id_sdm) akunSet.add(p.id_sdm);
            else if (p?.user?.id) akunSet.add(p.user.id);
            else if (p?.nama) akunSet.add(p.nama);
          });
        }
      });

      return {
        akun: akunSet.size,
        scopus,
        thomson,
        google,
        sinta
      };
    }

    return {
      akun: data?.akun || 0,
      scopus: data?.scopus || 0,
      thomson: data?.thomson || 0,
      google: data?.google || 0,
      sinta: data?.sinta || 0,
    };
  };

  const stats = getStats();

  return (
    <header className="relative z-30 bg-white text-brand-navy">
      <div className=" overflow-hidden bg-brand-navy text-white">
        <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-brand-gold to-transparent opacity-70" />
        <div className="pointer-events-none absolute -right-20 -top-24 h-56 w-56 rounded-full bg-brand-blue/30 blur-3xl" />
        <div className="mx-auto h-[94px] max-w-6xl items-center px-4 sm:px-6">
          <nav className="justify-between flex items-center gap-4 py-4">
            <Link
              to="/"
              className="inline-flex items-center gap-3 text-white no-underline flex-grow"
            >
              <img
                src={bookmarkImage}
                alt=""
                aria-hidden="true"
                className="absolute top-0 hidden w-32 sm:block lg:w-52"
              />
            </Link>
            <div className="items-center gap-1 rounded-full border border-white/10 bg-white/5 p-1 shadow-inner shadow-white/5 backdrop-blur md:flex ">
              <button
                type="button"
                onClick={goToGrafik}
                className="inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm font-bold text-white transition hover:bg-white/10 focus:outline-none focus:ring-2 focus:ring-brand-gold"
              >
                <Icon name="chart" />
                Grafik
              </button>
              <Link
                to="/repository"
                className="inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm font-bold text-white no-underline transition hover:bg-white/10 focus:outline-none focus:ring-2 focus:ring-brand-gold"
              >
                <Icon name="archive" />
                Repository
              </Link>
            </div>
            <div className="flex items-center gap-3">
              <button
                onClick={login}
                className="hidden items-center gap-2 rounded-full bg-brand-gold px-6 py-2.5 text-sm font-bold text-brand-navy transition hover:bg-yellow-400 focus:outline-none focus:ring-2 focus:ring-brand-gold focus:ring-offset-2 focus:ring-offset-brand-navy sm:inline-flex"
              >
                <Icon name="login" className="h-4 w-4" />
                Login
              </button>
              <button
                onClick={() => setOpen(true)}
                className="inline-flex items-center justify-center rounded-full bg-white/10 p-2 text-white transition hover:bg-white/20 focus:outline-none focus:ring-2 focus:ring-brand-gold md:hidden"
              >
                <Icon name="menu" className="h-5 w-5" />
              </button>
            </div>
          </nav>
        </div>
      </div>

      <div className="border-b border-slate-200 bg-white/95 shadow-sm backdrop-blur relative z-[-1] ">
        <div className="mx-auto flex min-h-16 max-w-6xl items-center gap-4 px-4 py-3 sm:px-6">
          <div className="flex min-w-0 flex-1 items-center justify-center gap-2 overflow-x-auto whitespace-nowrap pb-1">
            <StatItem>
              <span className="inline-flex h-7 w-7 items-center justify-center rounded-full bg-brand-navy text-white">
                <Icon name="users" className="h-3.5 w-3.5" />
              </span>
              {stats.akun} Users
            </StatItem>
            <StatItem>
              <img src={scopus} alt="Scopus" className="h-6 w-auto" />
              {stats.scopus}
            </StatItem>
            <StatItem>
              <img src={thomson} alt="Thomson Reuters" className="h-5 w-auto" />
              {stats.thomson}
            </StatItem>
            <StatItem>
              <img src={google} alt="Google Scholar" className="h-6 w-auto" />
              {stats.google}
            </StatItem>
            <StatItem>
              <img src={sinta} alt="Sinta" className="h-5 w-auto" />
              {stats.sinta}
            </StatItem>
          </div>

          <div className="hidden shrink-0 items-center gap-2 rounded-full bg-brand-soft px-3 py-2 text-sm font-bold text-slate-600 lg:inline-flex">
            <Icon name="calendar" className="h-4 w-4 text-brand-green" />
            {formattedDate}
          </div>
        </div>
      </div>

      {open ? (
        <div
          className="fixed inset-0 z-40 bg-brand-navy/70 backdrop-blur-sm md:hidden"
          onClick={() => setOpen(false)}
        >
          <div
            className="ml-auto flex h-full w-[min(20rem,88vw)] flex-col bg-brand-navy p-5 text-white shadow-2xl"
            onClick={(event) => event.stopPropagation()}
          >
            <div className="flex items-center justify-between">
              <div className="inline-flex items-center gap-3">
                <span className="inline-flex h-10 w-10 items-center justify-center rounded-lg bg-white p-2">
                  <img
                    src={unsamLogo}
                    alt=""
                    className="h-full w-full object-contain"
                  />
                </span>
                <span>
                  <span className="block font-display text-base font-extrabold">
                    RPU Unsam
                  </span>
                  <span className="block text-xs font-semibold text-white/60">
                    Menu Utama
                  </span>
                </span>
              </div>
              <button
                type="button"
                onClick={() => setOpen(false)}
                className="inline-flex h-10 w-10 items-center justify-center rounded-lg border border-white/20 bg-white/5"
                aria-label="Tutup menu"
              >
                <Icon name="close" className="h-5 w-5" />
              </button>
            </div>

            <div className="mt-8 flex flex-col gap-2">
              <button
                type="button"
                onClick={login}
                className="inline-flex items-center gap-3 rounded-lg bg-brand-gold px-4 py-3 text-left text-sm font-extrabold text-brand-navy transition hover:bg-white"
              >
                <Icon name="login" />
                Login SSO
              </button>
              <button
                type="button"
                onClick={goToGrafik}
                className="inline-flex items-center gap-3 rounded-lg px-4 py-3 text-left text-sm font-bold transition hover:bg-white/10"
              >
                <Icon name="chart" />
                Grafik
              </button>
              <Link
                to="/repository"
                onClick={() => setOpen(false)}
                className="inline-flex items-center gap-3 rounded-lg px-4 py-3 text-sm font-bold text-white no-underline transition hover:bg-white/10"
              >
                <Icon name="archive" />
                Repository
              </Link>
            </div>

            <div className="mt-auto rounded-lg border border-white/10 bg-white/5 p-4 text-xs leading-6 text-white/70">
              Akses data publikasi akademik Universitas Samudra melalui
              pencarian, repository, dan grafik statistik.
            </div>
          </div>
        </div>
      ) : null}
    </header>
  );
}

export default HeaderLogin;
